import styled from "styled-components";
import { flexCenterDir } from "../../style/theme";
import { useRecoilState } from "recoil";

import { accountName } from "../../store";
import NameForm from "./AccountForm";
import RepoForm from "./RepoForm";
import RepoList from "./RepoList";

const Main = () => {
	const [account, setAccount] = useRecoilState(accountName);

	return (
		<MainSection>
			{account === "" ? <NameForm /> : <RepoForm />}
			<RepoList />
		</MainSection>
	);
};

const MainSection = styled.main`
	${flexCenterDir}

	padding-top: 10rem;
`;

export default Main;
